import React from 'react';
const UpTriangle = (props) => {
    const attribute = Object.assign({}, props);
    const fill = attribute.fill || '#262A33';
    const fillOpacity = attribute.fillOpacity || '0.5';
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M3.60957 1.48804L0.649877 5.18765C0.387972 5.51503 0.621059 6 1.04031 6L6.95969 6C7.37894 6 7.61203 5.51503 7.35012 5.18765L4.39043 1.48804C4.19027 1.23784 3.80973 1.23784 3.60957 1.48804Z", fill: fill, fillOpacity: fillOpacity })));
};
export default UpTriangle;
